import React, { useState, useEffect, useRef } from 'react';
import { Option } from '@weave-design/menu';
import { StyledMenu, StyledFilter } from './DropdownFilter.styles';
import Dropdown from '@weave-design/dropdown';
import { InputLabel } from '@mui/material';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
export const DropdownFilter = ({ inputLabel, dropdownPlaceholder, withAllFilter = false, onFiltersChange, filters, }) => {
    const { t } = useGlobalization();
    const dropdownRef = useRef(null);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const onSelectFilter = (filter) => {
        const existsFilter = selectedFilters.includes(filter);
        let newSelectedFilters = [];
        if (existsFilter) {
            newSelectedFilters = selectedFilters.filter(item => item !== filter && item !== 'All');
        }
        else {
            newSelectedFilters = [...selectedFilters, filter];
        }
        if (withAllFilter && newSelectedFilters.length === filters?.length) {
            newSelectedFilters.push('All');
        }
        setSelectedFilters(newSelectedFilters);
        onFiltersChange(newSelectedFilters);
    };
    const selectAllFilters = () => {
        if (selectedFilters.includes('All')) {
            setSelectedFilters([]);
            onFiltersChange([]);
            return;
        }
        const newFilters = [...filters?.map(({ value }) => value), 'All'];
        setSelectedFilters(newFilters);
        onFiltersChange(newFilters);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (React.createElement(StyledFilter, { ref: dropdownRef },
        inputLabel ? React.createElement(InputLabel, null, inputLabel) : null,
        React.createElement(Dropdown, { value: dropdownPlaceholder, onClick: () => setIsMenuOpen(!isMenuOpen) }),
        isMenuOpen ? (React.createElement(StyledMenu, { multiple: true, checkmark: true, selected: selectedFilters },
            withAllFilter ? (React.createElement(Option, { id: "All", onClick: selectAllFilters }, t('All'))) : (React.createElement(React.Fragment, null)),
            filters
                ?.sort((a, b) => {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            })
                .map(({ label, value }) => (React.createElement(Option, { key: label, id: value, onClick: () => onSelectFilter(value) }, t(label)))))) : null));
};
